<template>
  <div class="msg-revoke" :class="{ mine: data.mine }">
    <span v-html="processedText" :title="formatTime" @click="onClick"></span>
  </div>
</template>

<script>
export default {
  inject: ['IMSDKType'],
  props: {
    data: Object,
  },
  computed: {
    processedText() {
      const revokeUser = this.data?.extuinInfo?.name || '对方';
      let text = `${revokeUser}撤回了一条消息`;
      if (this.data.mine) {
        text = '你撤回了一条消息';
      }
      if (
        this.data.revoke_mine
        && this.data.origin_type === this.IMSDKType.MSG_TEXT
      ) {
        text
          += ' <a href="javascript:void(0)">重新编辑</a>';
      }
      return text;
    },
    formatTime() {
      const date = new Date();
      return date.toLocaleDateString() + date.toLocaleTimeString();
    },
  },
  methods: {
    onClick() {
      if (
        this.data.revoke_mine
        && this.data.origin_type === this.IMSDKType.MSG_TEXT
      ) {
        this.$parent.insertTextToTextarea(this.data.content);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.msg-revoke {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  // margin-left: -40px;
  &.mine {
    margin-left: 0px;
    margin-right: -40px;
  }
  span {
    background: #fff;
    border-radius: 12px;
    color: #B4B8C4;
    padding: 2px 12px;
    display: inline-block;
  }
}

.html-is-pc{
  .msg-revoke span{
    background: #eceef1;
  }
}
</style>
